import { ThemeUICSSObject } from 'theme-ui';
import { captcha } from './captcha';
import { materialInput } from './materialInput';
/* IMPORT HERE */
export const forms: ThemeUICSSObject = {
  captcha,
  materialInput,
  /* PREPEND HERE */
};
